module.exports = __webpack_public_path__ + "image/CN_News5_photo.1727328807492.jpg";